import getDensityOptionState from '../store/store';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

export default function isDisplayDensityOptionDirty() {
    const densityOption = getDensityOptionState().densityModeSelected;

    return (
        densityOption !== null &&
        densityOption != getUserConfiguration().UserOptions.DisplayDensityMode
    );
}
